import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App as AntdApp } from 'antd'

import ScrollToTop from 'components/ui/scroll/ScrollToTop'
import App from './App'

function renderApp() {
    const root = ReactDOM.createRoot(document.getElementById('root'))
    root.render(
        <BrowserRouter>
            <AntdApp>
                <ScrollToTop />
                <App />
            </AntdApp>
        </BrowserRouter>,
    )
}

renderApp()
